let iconAdd = require("@/assets/images/cloudSee/icon-add.png")
let iconError = require("@/assets/images/cloudSee/icon-error.png")
let iconUse = require("@/assets/images/cloudSee/icon-use.png")
let iconcloud = require("@/assets/images/cloudSee/icon-cloud.png")
let chevronRight = require("@/assets/images/cloudSee/chevron-right.png")

module.exports = {
    help: {
        title: "title",
        search: "Please enter your question",
        myDevice: "my device",
        // 常见问题
        problemArr: [
            {
                type: 1,
                title: "Problem Solving",
                contentData: [
                    {
                        imgLeft: iconAdd,
                        imgLight: chevronRight,
                        oneTitle: "Add Device",
                        content: [
                            {
                                twoTitle: "How to add a second camera to your phone?",
                                text: [
                                    'Path: CloudSee - click “+” - select one method to setup camera (AP Hotspot/Sound/Ethernet cable)'
                                ],
                            },
                            {
                                twoTitle: "Why I still can’t hear much though I’ve turned the volume all the way up?",
                                text: [
                                    'Path: CloudSee -Device settings&nbsp;- Volume Settings - adjust the volume of Speaker and Mic',
                                ],
                            },
                            {
                                twoTitle: "APP shows wrong password, pls try",
                                text: [
                                    'evice settings - Delete camera - Reset camera - Setup camera again.',

                                ],
                            },
                            {
                                twoTitle: "Loud Whistling is heard when using two way talk feature on APP",
                                text: [
                                    "This is caused by the short distance of camera and your mobile phone. To improve this condition, please use this talk feature when you're at a further distance.",
                                ],
                            },
                            {
                                twoTitle: "If you can not receive alarm notifications after detecting a moving object, please confirm",
                                text: [
                                    '1.The Alarm for Motion Detection turns on (Path: CloudSee device settings; - Alarm ;Setting - turn on.“Alarm notification” ;- Motion detect - “Low”;- OK.',
                                    '2.The right for CloudSee to send notification; to your; phone (Path: phone settings - notifications - CloudSee; phone settings - all apps -; CloudSee - notifications).',
                                ],
                            },
                            {
                                twoTitle: "If camera can’t record normally, here are some tips",
                                text: [
                                    '1.Check whether your SD card is at Class 10.（8G-64G）',
                                    '2.Please the SD card status on app. (Path: CloudSee - device settings - Device info - TF-Card status) lf you have inserted it into the camera,but it shows there’s no TF-Card. Please plug off the power for camera and re-inserted SD card and then format the SD card in the app. (Path: CloudSee device settings - Maintenance device - TF-Card format).',
                                    '3.If still not work, pls format the SD card on your computer and choose FAT32 or exFAT when formating.',
                                ],
                            },
                            {
                                twoTitle: "Download the video",
                                text: [
                                    'If you want to download/delete the videos recorded on SD card, please take out your SD card and download/delete videos on your computer.',
                                ],
                            },
                            {
                                twoTitle: "Change your network provider or route",
                                text: [
                                    'If camera’s network connection breaks off after you change network provider or router, please reset this camera and re-install it.',
                                ],
                            },
                            {
                                twoTitle: "If you can not connect your camera with Wi-Fi successfully, please confirm",
                                text: [
                                    '1.Your home Wi-Fi network is 2 4G. Our camera does not support 5G Wi-Fi network. Please check your Wi-Fi Frequency band of the Wi-Fi router, or search its brand and model on google.',
                                    '2.If your router is dual band, please choose 2.4G Wi-Fi to connect your phone and the camera.',
                                    '3.Please put this Wi-Fi camera more close to the router.',
                                    '4.Please check if the Wi-Fi router is operating properly first, then turn on the DHCP of router, and set up WAP2-PSK for security recognized by the camera.',
                                    '5.If camera still fails to connect with wifi, please reset camera and reconnect it.',
                                ],
                            },

                        ],
                    },
                    {
                        imgLeft: iconError,
                        imgLight: chevronRight,
                        oneTitle: "Troubleshooting",
                        content: [
                            {
                                twoTitle: "Stay tuned for our",
                                text: [
                                    'Stay tuned for our',
                                ]
                            },
                        ],
                    },
                    {
                        imgLeft: iconUse,
                        imgLight: chevronRight,
                        oneTitle: "Function Use",
                        content: [
                            {
                                twoTitle: "Stay tuned for our",
                                text: [
                                    'Stay tuned for our'
                                ],
                            },
                        ],
                    },
                    {
                        imgLeft: iconcloud,
                        imgLight: chevronRight,
                        oneTitle: "Cloud Service",
                        content: [
                            {
                                twoTitle: "Stay tuned for our",
                                text: [
                                    'Stay tuned for our'
                                ],
                            },
                        ],
                    },
                ],
            },
            // {
            //     type: 2,
            //     title: "Operational Video",
            //     contentData: [
            //         {
            //             oneTitle: "Setup Camera by AP Hotspot",
            //             imgLight: chevronRight,
            //             playback:
            //                 "https://youtu.be/3e7573AJfbM",
            //         },
            //         {
            //             oneTitle: "Setup Camera by Ethernet Cable",
            //             imgLight: chevronRight,
            //             playback:
            //                 "https://youtu.be/JucdQ0I6N9g",
            //         },
            //         {
            //             oneTitle: "Setup Camera by Sound",
            //             imgLight: chevronRight,
            //             playback:
            //                 "https://youtu.be/61Gj4C7nZek",
            //         },
            //     ],
            // },
        ],
        yes: 'yes',
        no: 'no',
        share: 'share',
        noDevice: 'no device',
        operationVideo: 'operation video',
        loading: 'loading...',
        pageTitle: 'HelpAndFeedback',
        customerService: 'customerService',
        usertermsTitle: 'UserAgreement',
        privacyPolicyTitle: 'PrivacyPolicy',
        philipsCloudServiceTitle: 'Cloud service purchase',
        philipsAutoRenewTitle: 'autoRenew',
        birdsDetectionServiceTitle: 'Intelligent Detection Service Protocol',
        birdsAIDetectionServiceTitle: 'Insight Alarm Service Protocol',
        birdsDetectionAutoRenewTitle: 'autoRenew Protocol',
        rechargeTitle: 'Data Recharge',
        infoListTitle: '个人信息清单及SDK共享清单',
        userInfoTitle: '用户身份信息',
    }
};